import styled, { css } from 'styled-components';

import colors from '@utils/colors';
import { mq } from '@utils/responsive';
import { H_PADDING_MOBILE } from '@utils/space';
import { Heading as UnstyledHeading } from '@components/type';
import UnstyledImage from 'gatsby-image';

export const Content = styled.div`
  position: relative;
  z-index: 1;

  ${mq.gtsm`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  `}
  svg {
    position: absolute;
    width: 300px;
    height: 300px;
    left: -30px;
    top: 66%;
    z-index: -1;
    fill: ${(props) => props.outline && props.outline !== 'none' ?
      getThemeStyles(props.colorTheme).background :
      getThemeStyles(props.colorTheme).text};
    opacity: 0.2;

    ${mq.gtsm`
      width: 550px;
      height: 550px;
      left: -30px;
      top: 0;
  `}
  }
`;

export const Heading = styled(UnstyledHeading)`
  margin-bottom: 24px;
  color: ${(props) => props.outline && props.outline !== 'none' ?
    getThemeStyles(props.colorTheme).background :
    getThemeStyles(props.colorTheme).text};
  text-align: ${(props) => props.align};
  width: 100%;
  text-transform: uppercase;

  ${mq.gtsm`
    margin-bottom: 32px;
  `}
`;

export const Image = styled(UnstyledImage)`
  img {
    filter: brightness(70%) contrast(120%);
  }
`;

export const Stories = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  flex-direction: column-reverse;
  align-items: flex-end;

  ${mq.gtms`
    flex-direction: row;
    align-items: flex-start;
  `}
`;

export const Story = styled.div`
  flex: 1 1 ${props => props.size === 'small' ? '33%' : '50%'};
  position: relative;
  width: ${props => props.size === 'small' ? '70%' : '100%'};

  ${mq.gtms`
    transform: unset;
  `}

`;

export const StoryData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${mq.gtms`
      bottom: unset;
      top: 16px;

  `}
`;

export const Link = styled(UnstyledHeading)`
  text-transform: uppercase;
  width: 100%;
  font-size: 30px;
  margin-top: 10px;

  ${mq.gtms`
    font-size: 42px;
      margin-top: 10px;

`}
  a {
    color: ${(props) => props.outline && props.outline !== 'none' ?
      getThemeStyles(props.colorTheme).background :
      getThemeStyles(props.colorTheme).text};
    text-decoration: inherit;
    line-height: 1;
  }
`;

export const Tag = styled(UnstyledHeading)`
  text-transform: uppercase;
  position: absolute;
  top: 12px;
  right: 20px;
  width: 100%;
  font-size: 16px;
  margin-top: 10px;
  text-align: right;

  a {
    color: ${(props) => props.outline && props.outline !== 'none' ?
      getThemeStyles(props.colorTheme).background :
      getThemeStyles(props.colorTheme).text};
    text-decoration: inherit;
    line-height: 1;
    background: #fff;
    padding: 5px;
    border-radius: 5px;
  }
`;

export const Inner = styled.div`
  width: 100%;
  position: relative;
  z-index: 1;
  padding: 18px ${H_PADDING_MOBILE};

  ${mq.gtmd`
    padding: 0 calc((100vw - 1280px) / 2);
  `}
  & > svg {
    position: absolute;
    top: 20%;
    right: -200px;
    left: -100px;
    width: calc(100% + 300px);
    z-index: 0;

    ${mq.gtsm`
      top: ${props => props.flipped ? 'auto' : '0'};
      bottom: ${props => props.flipped ? '0' : 'auto'};
      right: 50%;
      left: 0;
      width: 50%;
    `}
  }
`;

export const Wrapper = styled.div`
  //overflow: hidden;

  & > svg {
    z-index: 0;
  }

  & > svg:first-of-type {
    fill: ${(props) =>
      props.outline && props.outline !== 'none' ? 'none' : getThemeStyles(props.colorTheme).background};
    stroke: ${(props) =>
      props.outline === 'top' || props.outline === 'both'
        ? getThemeStyles(props.colorTheme).outline
        : 'none'};
    stroke-width: ${(props) =>
      props.outline === 'top' || props.outline === 'both' ? '3px' : 0};
    vertical-align: bottom;

    ${mq.gtsm`
      stroke-width: 1px;
    `}

    ${(props) =>
      props.outline && props.outline !== 'none' &&
      css`
        width: calc(100% + 6px);
        margin-right: -3px;
        margin-bottom: -3px;
        margin-left: -3px;
      `}
  }

  & > svg:last-of-type {
    fill: ${(props) =>
      props.outline && props.outline !== 'none' ? 'none' : getThemeStyles(props.colorTheme).background};
    stroke: ${(props) =>
      props.outline === 'bottom' || props.outline === 'both'
        ? getThemeStyles(props.colorTheme).outline
        : 'none'};
    stroke-width: ${(props) =>
      props.outline === 'bottom' || props.outline === 'both' ? '3px' : 0};
    transform: scale(-1, -1) translateY(1px);
    vertical-align: top;

    ${mq.gtsm`
      stroke-width: 1px;
    `}

    ${(props) =>
      props.outline &&
      css`
        width: calc(100% + 6px);
        margin-right: -3px;
        margin-top: -1px;
        margin-left: -3px;
      `}
  }
`;

export function getThemeStyles(theme) {
  switch (theme) {
    case 'white':
      return {
        outline: colors.B500,
        background: '#fff',
        swirl: colors.B100,
        fill: colors.B200,
        text: colors.B500,
      };
    case 'dark-blue':
      return {
        outline: colors.B500,
        background: colors.B500,
        fill: colors.B200,
        text: '#fff',
      };
    case 'dark-purple':
      return {
        outline: colors.P500,
        background: colors.P500,
        fill: colors.P200,
        text: '#fff',
      };
    case 'green':
      return {
        outline: colors.G100,
        background: colors.G100,
        fill: colors.G200,
        text: colors.G500,
      };
    case 'orange':
      return {
        outline: colors.O100,
        background: colors.O100,
        fill: colors.O200,
        text: colors.O500,
      };
    default:
      return {
        outline: colors.Y100,
        background: colors.Y100,
        fill: colors.Y200,
        text: colors.B500,
      };
  }
}
